module.exports = __webpack_public_path__ + "img/step1.5f6eb817.svg";